module.exports = __webpack_public_path__ + "static/media/selectArea.5fd447b3.svg";